
import useConfigurationTrial from "@/hooks/data/useConfigurationTrial";
import { createContext } from "react"

export interface IConfigurationTrialContext extends ReturnType<typeof useConfigurationTrial> {
}

export const ConfigurationTrialContext = createContext<IConfigurationTrialContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ConfigurationTrialContext;